// error pages
export const NOT_FOUND = '/404';
export const ACCESS_DENIED = '/403';

// General Routes
export const ROUTE_HOME = '/';
export const ROUTE_HOME_EXPLICIT = '/home';

// auth section
export const ROUTE_LOGIN = '/login';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_FORGOT_NEW_PASSWORD = '/forgot-password/:token';
export const ROUTE_ACCOUNT_VERIFY = '/account/verify/:userId/:verificationHash';
export const ROUTE_RESEND_ACTIVATION = '/resend-activation-email';
export const ROUTE_VERIFY_ADMIN = '/admin/account/verify/:id/:hash';

// profile
export const ROUTE_PROFILE = '/profile';

// dashboardROUTE_CLIENT_ORDER_VIEW
export const ROUTE_DASHBOARD = '/dashboard';

// order management
export const ROUTE_CLIENT_ORDERS = '/orders';
export const ROUTE_CLIENT_ORDER_VIEW = '/orders/:id'
export const ROUTE_CLIENT_ORDER_CREATE = '/create-order'

//certificates
export const ROUTE_CLIENT_CERTIFICATES = '/certificates'

// documents
export const ROUTE_DOCUMENTS = '/documents'
export const ROUTE_DOCUMENT_VIEW = '/documents/:documentId'
export const ROUTE_PACKAGE_VIEW = '/packages/:packageId'

// order management
export const ROUTE_CLIENT_CAMPAIGN = '/campaigns';
export const ROUTE_CLIENT_CAMPAIGN_VIEW = '/campaigns/:id'
export const ROUTE_CLIENT_CAMPAIGN_CREATE = '/create-campaign'

// Theme routes
export const THEME_ROUTE_HOME = '/theme';
export const THEME_ROUTE_ADMIN = '/theme/admin';
export const THEME_ROUTE_RTL = '/theme/rtl';
export const THEME_ROUTE_AUTH = '/theme/auth';

// clients route
export const ROUTE_CLIENT_USERS = '/users';
export const ROUTE_CLIENT_USER_VIEW = '/users/:userId';

// admins route
export const ROUTE_ADMIN_USERS = '/admin/users';
export const ROUTE_ADMIN_USERS_VIEW = '/admin/users/:userId';
export const ROUTE_ADMIN_MANAGE = '/admin/manage';
export const ROUTE_ADMIN_GROUPS_VIEW = '/admin/groups/:groupId';

// reports route
export const ROUTE_REPORTS = '/reports';
export const ROUTE_REPORTS_GENERAL = '/reports/general';

// tickets routes
export const ROUTE_CLIENT_TICKETS = '/tickets';
export const ROUTE_CLIENT_TICKETS_VIEW = '/tickets/:ticketId';


// appointments routes
export const ROUTE_APPOINTMENTS = '/appointments';
export const ROUTE_APPOINTMENTS_SETTINGS = '/appointments/settings';

export const ROUTE_STATIC_PAGES = [
  ROUTE_HOME,
  ROUTE_HOME_EXPLICIT,
]

//organizations routes
export const ROUTE_CLIENT_ORGANIZATIONS = '/organizations';
export const ROUTE_CLIENT_ORGANIZATIONS_VIEW = '/organizations/:organizationId';

// email campaigns routes

export const ROUTE_CLIENT_EMAIL_CAMPAIGN_CREATE = '/create-email-campaign';
export const ROUTE_CLIENT_EMAIL_CAMPAIGNS = '/email-campaigns';
export const ROUTE_CLIENT_EMAIL_CAMPAIGN_VIEW = '/email-campaigns/:emailCampaignId';
